import { useQuery } from "react-query";
import { fetchData } from "../api/client";
import { workspaceScopedQueryKey } from "../utils/workspaceQueryScope";

// Função auxiliar para mapear status numérico para string
const getStatusLabelFromCode = (status) => {
  const statusMap = {
    0: "Pendente",
    1: "Em Atendimento",
    2: "Concluída",
    3: "Contato Futuro",
    4: "Perdida",
    5: "Cancelada",
  };

  // se já veio como string legível, devolve como está
  if (typeof status === "string" && isNaN(Number(status))) {
    return status;
  }
  const n = typeof status === "string" ? Number(status) : status;
  return statusMap[n] ?? "Desconhecido";
};

export const useConversationDetails = (conversationId) => {
  const isPersonalSynthetic =
    conversationId != null &&
    String(conversationId).startsWith("wa-personal:");
  return useQuery(
    workspaceScopedQueryKey("conversationDetails", conversationId),
    () => fetchData(`/conversations/${conversationId}`, "GET"),
    {
      enabled: !!conversationId && !isPersonalSynthetic,
      staleTime: 10_000,
      refetchOnWindowFocus: false,
      refetchInterval: (data) => {
        const d = data?.data;
        if (d?.webchatRedirectEnabled || d?.webchatAtivo || d?.webchatPresence) {
          return 12_000;
        }
        return false;
      },
      retry: (failureCount, error) => {
        const status = Number(error?.status ?? error?.httpStatus ?? error?.response?.status);
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
      select: (response) => {
        const data = response.data || {};
        return {
          data: {
            ...data,
            statusLabel: getStatusLabelFromCode(data.status),
          },
        };
      },
    }
  );
};
